import React from 'react';
import { Spinner } from "react-bootstrap";
import { FileStore } from "../stores/FileStore";
import axios from 'axios';
import { withTranslation } from "react-i18next";
import HighchartsReact from 'highcharts-react-official';
import Highcharts from 'highcharts';
import networkgraph from "highcharts/modules/networkgraph";
networkgraph(Highcharts);


const CytoscapeGraph = (props) => {

  const clickedRegionObject = FileStore.useState((s) => s.clickedRegionObject);
  const p_value_cutoff = FileStore.useState((s) => s.p_value_cutoff);

  const graphData = FileStore.useState((s) => s.graphData);
  const pathwaySelection = FileStore.useState((s) => s.pathwaySelection);

  var nodes1 = [];
  var data1 = [];

  const[showMessage, setShowMessage] = React.useState(true);

  const [options, setOptions] = React.useState({
    chart: {
      type: "networkgraph",
    },
    title: {
      text: ''
    },
    plotOptions: {
      networkgraph: {
        keys: ['from', 'to'],
        layoutAlgorithm: {
          enableSimulation: false,
          friction: -0.9
        },
        point: {
          events: {
            click: function() {
              if (this.color === "#7cb5ea") {
                  var url = "https://classic.wikipathways.org//index.php?query=" + this.id.split(' ').join('+') + '&species=Homo+sapiens&title=Special%3ASearchPathways&doSearch=1&ids=&codes=&type=query';
                  window.open(url, "_blank");
              } else if (this.color === "#7cb5ec") {
                  var url = "https://www.ncbi.nlm.nih.gov/gene/?term=(" + this.id + '[GN])+AND+"Homo+sapiens"[porgn:__txid9606]';
                  window.open(url, "_blank");
              }
            }
          }
        }
      }
    },
    series: [{
      dataLabels: {
        enabled: true,
        linkFormat: ''
      },
      id: 'lang-tree',
      data: [],
      nodes: []
    }]
  });

  React.useEffect(() => {
    axios.get('http://compcorona.mu.edu.tr/string-db-api/get-data')
      .then((response) => {
         response.data.forEach((obj) => {
            data1.push([
                obj["cluster"],
                obj["gene"]
              ]);
              nodes1.push({
                id: obj["cluster"],
                marker: {
                  radius: 10,
                },
                color: '#7cb5ea'
              })
          });
              setOptions({
                series: [
                  { data: data1, nodes: nodes1}
                ]
              });
              setShowMessage(false);
      }, (error) => {
        //console.log(error);
     });
  }, []);


    return(
      <div style={{width: '100%', height: '95vh'}}>
          <h3 style={{margin: '2% 0 1% 0'}}>{props.t("interaction.graph")}</h3>
          <h5 style={{margin: '10% 0 2% 0', color: '#e04f4f', display: showMessage ? 'block' : 'none' }}>{props.t("wait")}<br></br></h5>
          <Spinner style={{margin: '2% auto', display: showMessage ? 'block' : 'none' }} animation="border" variant="danger" />
          <HighchartsReact
              containerProps={{ style: { height: "90%" } }}
              style={{display: showMessage ? 'none' : 'block' }}
              highcharts={Highcharts}
              options={options}
            />
      </div>
    );
};

export default withTranslation()(CytoscapeGraph);
